import React from "react";
import PropTypes from "prop-types";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";

import BookmarksIcon from "@material-ui/icons/Bookmarks";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";

import AdapterLink from "../../AdapterLink";

const useStyles = makeStyles(({ palette }) => {
  return {
    icon: {
      color: palette.text.secondary
    },
    text: {
      color: palette.text.primary
    },
    chevron: {
      color: palette.text.secondary
    }
  };
});

const defaultPaymentFamilies = [
  {
    path: "savedcard",
    code: "CARD",
    name: "Saved Cards",
    icon: <BookmarksIcon />
  },
  { path: "card", code: "CARD", name: "Card", icon: <CreditCardIcon /> },
  {
    path: "ib",
    code: "NET_BANKING",
    name: "Netbanking",
    icon: <AccountBalanceIcon />
  },
  { path: "upi", code: "UPI", name: "UPI", icon: <AccountBoxIcon /> },
  {
    path: "wallet",
    code: "WALLET",
    name: "Wallet",
    icon: <AccountBalanceWalletIcon />
  }
  // { path: "emi", name: "EMI", icon: <ScheduleIcon /> }
];

const PaymentList = ({ match, charge }) => {
  const classes = useStyles();
  const { customerSavedCards, customerId, paymentFamilies } = charge;
  let paymentToDisplay = defaultPaymentFamilies;
  const shouldHideSavedCards =
    !customerId || !customerSavedCards || customerSavedCards.length === 0;
  if (shouldHideSavedCards) {
    paymentToDisplay = defaultPaymentFamilies.filter(
      f => f.path !== "savedcard"
    );
  }
  return (
    <List component="nav">
      {paymentToDisplay
        .filter(
          paymentFamily =>
            paymentFamilies.families.indexOf(paymentFamily.code) !== -1
        )
        .map(paymentFamily => {
          return (
            <ListItem
              button
              key={paymentFamily.name}
              id={paymentFamily.path}
              component={AdapterLink}
              to={`${match.url}/${paymentFamily.path}`}
            >
              <ListItemIcon className={classes.icon}>
                {paymentFamily.icon}
              </ListItemIcon>
              <ListItemText
                className={classes.text}
                primary={paymentFamily.name}
              />
              <ChevronRightIcon className={classes.chevron} />
            </ListItem>
          );
        })}
    </List>
  );
};

PaymentList.propTypes = {
  match: PropTypes.shape().isRequired,
  charge: PropTypes.shape({
    customerSavedCards: PropTypes.arrayOf(PropTypes.shape()),
    customerId: PropTypes.string,
    paymentFamilies: PropTypes.shape().isRequired
  }).isRequired
};

export default PaymentList;
